export default __webpack_public_path__ + "static/logo-103cbd471d99d103f6e0d46e3be23705.png";